<template>
  <div class="main_box" v-loading="loading">
    <!-- 头部信息 -->
    <div id="MergeHeader" class="flex flex_layout_between">
      <div class="buyerInfo">
        <div class="merger_title">{{ $t('menu.mergeOrders') }}</div>
        <el-avatar class="user_img" :src="list.length && list[0].HeadPortrait ? list[0].HeadPortrait + $store.state.thumbnail : '/static/images/noimg.svg'"></el-avatar>
        <div class="uname">{{ list.length && list[0].RealName ? list[0].RealName : '' }}</div>
      </div>
      <div class="cancel_btn">
        <el-button icon="el-icon-circle-close" @click="$router.go(-1)">{{ $t('button.cancel') }}</el-button>
      </div>
    </div>

    <!-- 收货地址列表 -->
    <div class="address_list" v-if="addresList.length">
      <div class="adds_block active" v-for="(obj, k) in addresList" :index="k" :key="k">
        <div class="adds_row u_name">{{ obj.Consignee ? obj.Consignee : '' }} ({{ obj.Nation ? obj.Nation : '' }})</div>
        <div class="adds_row u_address">{{ obj.Provice ? obj.Provice : '' }}, {{ obj.Address ? obj.Address : '' }}</div>
        <!-- <div class="adds_row u_phone">ZipCode: {{ obj.ZipCode ? obj.ZipCode : '' }}</div> -->
        <div class="adds_row u_phone">{{ $t('enum.mobile') }}: {{ obj.Mobile ? obj.Mobile : '' }}</div>
      </div>
    </div>

    <div class="order_overflow" ref="orderTopList">
      <!-- 订单列表头 -->
      <div class="order_title" ref="orderTitle">
        <div class="order_list order_header">
          <div class="card_detail">
            <!-- 全选框 -->
            <div class="cd_info com_box" style="width:88px;">
              <el-checkbox class="checkbox_all" v-if="!doubleCheck" v-model="isCheck" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
              </el-checkbox>
            </div>
            <div class="cd_info com_box" style="min-width:200px;flex: 1;">{{ $t('enum.commodity') }}</div>
            <div class="cd_info align_r">{{ $t('enum.itemPrice') }}</div>
            <div class="cd_info shipment align_r" v-if="!doubleCheck">{{ $t('enum.shippingFee') }}</div>
            <div class="cd_info align_r" v-if="!doubleCheck">{{ $t('enum.orderTotal') }}</div>
          </div>
        </div>
        <!-- <h4>{{tabname}}</h4> -->
      </div>
      <!-- 订单列表 -->
      <div id="OrderList" ref="OrderList" :class="['table_box']" :style="{ 'height': (screenHeight ? screenHeight + 'px' : 'auto') }">
        <div class="order_list_detail" v-for="(item, index) in list" :key="index">
          <div v-if="!item.hide">
            <div class="order_detail_box">
              <!-- 选择框 -->
              <div style="width: 50%;display: flex;">
                <el-checkbox-group v-if="!doubleCheck" class="checkbox_table" v-model="multipleSelection" @change="handleCheckedChange">
                  <el-checkbox :key="item.ID" :label="item.ID" :disabled="orderId == item.ID && !canChangeMainId ? true : false"></el-checkbox>
                </el-checkbox-group>
                <span>{{ item.CreateDate ? $store.getters.getTime(item.CreateDate, $store.state.lang.indexOf("zh") > -1 ? 8 : -8) : '' }}</span>
              </div>
              <span>{{ $t('enum.orderNumber') }}:<em>{{ item.Code }}</em></span>
            </div>
            <div class="flex order_list">
              <div class="card_detail_box">
                <div class="card_detail" v-for="(obj, k) in item.Details" :key="k">
                  <!-- 图片 -->
                  <div class="cd_info com_box order-title" style="width:88px;">
                    <el-image class="like_img" :src="obj.TitImg && obj.TitImg != '没有可上传的图片' ? obj.TitImg + $store.state.thumbnail : '/static/images/noimg.svg'" fit="contain">
                    </el-image>
                  </div>
                  <!-- 标题 -->
                  <div class="cd_info com_box order-title" style="min-width:200px;flex: 1;">
                    <p style="word-break: break-word;display: -webkit-box;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;-webkit-line-clamp: 3;">
                      {{ $store.getters.setTitle(obj.Title, 'all') }}</p>
                  </div>
                  <!-- 单价 -->
                  <div class="cd_info align_r">
                    <div>{{ priceUnit }} {{ item.USDRate ? (obj.Price * item.USDRate).toFixed(2) : '' }}</div>
                  </div>
                  <!-- 运费 -->
                  <div class="cd_info shipment align_r" v-if="!doubleCheck">
                    <div>{{ priceUnit }} {{ item.USDRate ? (item.PostageMoney * item.USDRate).toFixed(2) : '' }}</div>
                  </div>
                  <!-- 总价 -->
                  <div class="cd_info align_r" v-if="!doubleCheck">
                    <div class="PostageMoney">
                      {{ priceUnit }}
                      {{ item.USDRate ? (obj.Price * item.USDRate + item.PostageMoney * item.USDRate).toFixed(2) : '' }}
                    </div>
                  </div>
                  <!-- / -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- MergeFooter -->
      <div id="MergeFooter" v-if="!doubleCheck">
        <div class="mf_block select_info">
          <!-- 全选框 -->
          <el-checkbox class="checkbox_all" v-model="isCheck" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
            {{ $t('enum.selectAll') }}
          </el-checkbox>
          <div>{{ multipleSelection.length }} {{ multipleSelection.length != 1 ? $t('enum.items') : $t('enum.item') }} {{ $t('enum.selected') }}</div>
        </div>
        <div class="mf_block shipping">
          <div class="op_ov">
            {{ $t('enum.shippingFee') }}:
          </div>
          <el-form ref="FormBox" :model="FormData" :rules="rules">
            <el-form-item required prop="PostageMoney">
              <el-input v-model="FormData['PostageMoney']" type="number" min="0" max="1000000" v-on:input="PriceInput('PostageMoney')">
                <template slot="prepend">{{ priceUnit }}</template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="mf_block merge_operate">
          <div class="op_ov order_total">
            {{ $t('enum.orderTotal') }}: <b>{{ priceUnit }} {{ OrderTotal }}</b>
          </div>
          <el-button type="primary" @click="SubmitMerge">{{ $t('button.confirm') }}</el-button>
        </div>
      </div>
      <!-- doubleCheck -->
      <div v-if="doubleCheck" class="double_check">
        <div class="dbck_block dbck_total">
          <div class="total_row"><span>{{ $t('enum.subtotal') }}:</span><span>{{ priceUnit }} {{ ThousandAndDecimal(Subtotal) }}</span></div>
          <div class="total_row"><span>{{ $t('enum.shipping') }}:</span><span>{{ priceUnit }} {{ FormData.PostageMoney }}</span></div>
          <div class="total_row"><span>{{ $t('enum.orderTotal') }}:</span><span>{{ priceUnit }} {{ ThousandAndDecimal(OrderTotal) }}</span></div>
        </div>
        <div class="dbck_block dbck_btns">
          <el-button icon="el-icon-back" @click="mergeBack">{{ $t('button.back') }}</el-button>
          <el-button type="primary" @click="getData('SubmitMergeOrders')">{{ $t('button.confirmMerge') }}</el-button>
        </div>
      </div>
    </div>
    <!-- {{ Id }} -->
  </div>
</template>

<script>

export default {
  name: "",
  components: {},
  data() {
    return {
      buyerId: '',//买家ID
      orderId: "",//主订单ID
      priceUnit: "USD",//货币单位
      canChangeMainId: true,//点击进入的主订单是否可点选
      BusinessType: null,//主订单类型跨境 = 2,  海外同区域 = 3,
      loading: false,
      submitLoading: false,
      wyimLink: `${this.$store.getters.CHAT()}`,
      screenHeight: 200,
      doubleCheck: false,
      isCheck: false,
      isIndeterminate: false,
      multiple: 1,//默认0
      multipleSelection: [],
      checkNum: 0,//显示可选个数 全部 0
      OrderTotal: 0,//总价[含运费]
      Subtotal: 0,//总价[不含运费]
      FormData: {
        MainOrderId: null,//主订单ID
        MergeIds: [],//订单ID  列  ：  1,2,3
        PostageMoney: null,//运费
        ArrivalPay: 0,//到付？ 0：否  1：是
      },//
      rules: {//表单验证
        PostageMoney: [{ required: true, message: this.$t('tips.plsFillShippingFee'), trigger: ['blur', 'change'] }]
      },
      addresList: [],
      mergeList: [],//选择后的列表
      list: [],
      newList: []
    };
  },
  created: function () {
    var that = this;
    var _uid = that.$route.query.uid || '';
    var _oid = that.$route.query.oid || '';
    that.buyerId = _uid;
    that.orderId = _oid;
    this.tabHeight();
  },
  mounted() {
    var that = this;
    this.getWidth();
    window.addEventListener('resize', () => {
      this.tabHeight()
    })
    that.getData("MergeOrders", `?MainOrderId=${that.orderId}&BuyerId=${that.buyerId}`);//获取可合并订单列表
  },
  watch: {
    FormData: {
      handler(fd, oldVal) {
        var orderTotal = 0;
        var subtotal = 0;
        if (fd['MergeIds'] && fd['MergeIds'].length) {
          this.list.map((obj, k) => {
            if (fd['MergeIds'].includes(obj.ID)) {
              var p = obj.USDRate ? (obj['Details'][0].Price * obj.USDRate).toFixed(2) : 0;
              orderTotal = this.plus(p, orderTotal).toFixed(2);
              subtotal = orderTotal;
              // console.log("obj: ", p, orderTotal);
            }
          });
        }
        if (fd['PostageMoney'] >= 0) {
          orderTotal = this.plus(fd['PostageMoney'], orderTotal).toFixed(2);
        }
        this.OrderTotal = orderTotal;
        this.Subtotal = subtotal;
        // console.log("watch FormData", fd);
      },
      deep: true,
    },
  },
  computed: {
    ThousandAndDecimal() {
      return function (num) {
        //金额千分位
        var val = "";
        if (num) {
          val = parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        }
        return val
      }
    }
  },
  methods: {
    // 获取订单详情
    getData(api, params = "") {
      var that = this;
      var fun = "", method = "GET";
      switch (api) {
        case "MergeOrders": //获取买家可合并订单列表
          that.loading = true;
          fun = function (res) {
            if (res.result) {
              var _data = res.data;
              that.list = _data;
              that.isIndeterminate = true;
              that.multipleSelection = [parseInt(that.orderId)];
              that.FormData['MergeIds'] = [parseInt(that.orderId)];
              that.FormData['MainOrderId'] = parseInt(that.orderId);
              that.BusinessType = _data[0]['BusinessType'];
              //that.priceUnit = _data[0]['SellRealMoneyUnit']?_data[0]['SellRealMoneyUnit']:
              (_data[0]['SellMemberSource']=="CN"?"CNY":(_data[0]['SellMemberSource']=="MO"?"MOP":"USD"));//货币单位
              that.getData("GetOrderAddress");//获取地址
            }
            that.loading = false;
          };
          that.$get(api, params)
            .then((res) => {
              console.log("axios-res:", api, res);
              fun(res);
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case "GetOrderAddress": //获取买家收货地址
          if (that.multipleSelection.length <= 0 || !that.multipleSelection[0]) {
            return false;
          }
          var firstID = that.multipleSelection[0];
          if (that.BusinessType == 3) {
            //海外同区域 根据主订单ID获取买家收货地址
            params = `?OrderId=${firstID}`;
            fun = function (res) {
              if (res.result) {
                that.addresList = [{ ...res.data }];
              }
            };
            that.$get(api, params)
              .then((res) => {
                console.log("axios-res:", api, res);
                fun(res);
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            //非同区域，获取主订单内的收货地址(转运仓地址)
            var _list = that.list;
            var _addresList = [];
            _list.map((obj, k) => {
              if (firstID == obj.ID) {
                _addresList.push(obj.ReceiverAddress);
              }
            });
            that.addresList = _addresList;
          }
          break;
        case "SaveMergePreviewPost"://卖家合并订单预览
          if (that.loading) {
            return false;
          }
          that.loading = true;
          const p = that.FormData;
          const MergeIds = p.MergeIds.toString();
          console.log("MergeIds", MergeIds)
          var PostageMoneyCH = that.$store.getters.priceExchange(p.PostageMoney, '', that.list[0]['USDRate']);
          //[get] params = `?MainOrderId=${p.MainOrderId}&MergeIds=${p.MergeIds}&PostageMoney=${PostageMoneyCH}&ArrivalPay=${p.ArrivalPay}`
          params = {
            MainOrderId: p.MainOrderId,
            MergeIds: MergeIds,
            PostageMoney: PostageMoneyCH,
            ArrivalPay: p.ArrivalPay
          }
          fun = function (res) {
            if (res.result) {
              var _shippingFeeCH = that.$store.getters.priceExchange(that.FormData['PostageMoney']);
              var _order = that.multipleSelection;
              that.doubleCheck = true;
              var _list = that.list;
              var _OrderIDs = that.FormData['MergeIds'];
              _list.map((obj, k) => {
                if (_OrderIDs.includes(obj.ID)) { obj['hide'] = false; } else { obj['hide'] = true }
              });
              that.mergeList = _list;
              that.screenHeight = 0;
              console.log("POST MergeOrders:", _order, _list);
            }
            that.loading = false;
          };
          that.$post(api, params)
            .then((res) => {
              console.log("axios-res:", res);
              fun(res);
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case "SubmitMergeOrders"://合并订单
          if (that.loading) {
            return false;
          }
          that.loading = true;
          params = that.FormData;
          fun = function (res) {
            if (res.result) {
              that.$router.push({ name: "orders" });
            }
            that.loading = false;
          };
          that.$post(api, params)
            .then((res) => {
              console.log("axios-res:", res);
              fun(res);
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        default:
          break;
      }
    },
    SubmitMerge() {
      var that = this;
      if (that.multipleSelection.length < 2) {
        that.$message.warning({
          message: this.$t('tips.plsSelLeastTwo'),
          offset: 280,
        });
        return;
      }
      this.$refs.FormBox.validate(function (valid) {
        if (valid) {
          console.log('success validate!!');
          // that.submitLoading = true;
          that.getData('SaveMergePreviewPost');
        } else {
          //that.$set(that.FormData, 'PropertyJson', '');
          console.log('error submit!!');
          that.submitLoading = false;
          return false;
        }
      });
    },
    plus(a, b) {
      //加法（小数点问题）
      let c, d, m;
      try {
        c = a.toString().split(".")[1].length;
      } catch (e) { c = 0; }
      try {
        d = b.toString().split(".")[1].length;
      } catch (e) { d = 0; }
      m = Math.pow(10, Math.max(c, d));
      return (a * m + b * m) / m;
    },
    mergeBack() {
      //二次确认返回
      let that = this;
      that.doubleCheck = false;
      var _list = that.list;
      _list.map((obj, k) => {
        obj['hide'] = false;
      });
      that.tabHeight();
    },
    PriceInput(type) {
      //价格判断
      let that = this;
      let _Price = that.FormData[type]
        .toString()
        .replace(/[^\d.]/g, "") // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, ".") // 只保留第一个. 清除多余的
        .replace(/^\./g, "") //保证第一个为数字而不是.
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
      if (_Price.indexOf(".") < 0 && _Price != "") {
        _Price = parseFloat(_Price);
      }
      that.$set(that.FormData, type, _Price);
    },
    // 全/不选时统计条数
    handleCheckAllChange(value) {
      var that = this;
      var _list = [];
      var firstID = null;
      /** 全选框 是否限制的个数 **/
      this.list.filter((obj, k) => {
        if (k == 0 && !that.canChangeMainId) { firstID = obj.ID };//第一条、进入时的主订单
        if (that.checkNum > 0 && k < that.checkNum) { _list.push(obj.ID) }
        else { _list.push(obj.ID) }
      });

      var _multipleSelection = value ? _list : (firstID ? [firstID] : []);
      _multipleSelection = _multipleSelection.length ? _multipleSelection.sort(function (m, n) {
        return n - m;
      }) : _multipleSelection;
      this.multipleSelection = _multipleSelection;
      this.isIndeterminate = false;// false全不选，true全选
      this.multiple = that.multipleSelection.length;
      this.FormData['MergeIds'] = that.multipleSelection;
      var _MainOrderId = that.FormData['MergeIds'][0] ? that.FormData['MergeIds'][0] : null;
      if (that.FormData['MainOrderId'] != _MainOrderId) {
        this.$set(that.FormData, 'MainOrderId', _MainOrderId);
        if (that.canChangeMainId) {
          that.getData('GetOrderAddress')//获取地址
        }
      }
    },
    // 单选统计条数
    handleCheckedChange(value) {
      var that = this;
      let checkedCount = value.length;
      this.isCheck = checkedCount === that.list.length;
      var _multipleSelection = that.multipleSelection;
      _multipleSelection = _multipleSelection.sort(function (m, n) {
        return n - m;
      });
      this.multiple = _multipleSelection.length;// 勾选选中的
      this.isIndeterminate = checkedCount > 0 && checkedCount < that.list.length;// 勾选的长度范围
      this.$set(that.FormData, 'MergeIds', _multipleSelection);
      var _MainOrderId = _multipleSelection[0] ? _multipleSelection[0] : null;
      // console.log("handleCheckedChange", value, that.multipleSelection,_MainOrderId,that.FormData['MainOrderId']);
      if (that.FormData['MainOrderId'] != _MainOrderId) {
        this.$set(that.FormData, 'MainOrderId', _MainOrderId);
        if (that.canChangeMainId) {
          that.getData('GetOrderAddress')//获取地址
        }
      }
    },
    // 获取order_title 长度
    getWidth() {
      let tabwidth = this.$refs.OrderList.offsetWidth == '1108' ? this.$refs.OrderList.offsetWidth : this.$refs.OrderList.offsetWidth + 15;
      this.titleWidth = tabwidth
      // this.$emit('refresh', this.titleWidth)
    },
    // 获取list固定长度
    tabHeight() {
      this.screenHeight = document.body.clientHeight;
      let Sheight = this.screenHeight - 70 - 48 - 133 - 48 - 60 - 100;
      this.$nextTick(() => {
        // console.log(Sheight );
        this.screenHeight = Sheight
      })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/orderlist.css";

.order_title {
  margin: 0 0 20px;
  /* position: fixed; */
  z-index: 1;
}

.order_overflow {
  position: relative;
}

.order_list,
.order_header {
  min-height: 48px;
  line-height: 48px;
}

.order_header {
  background-color: #f7f7f7;
}

.order_list>div {
  line-height: 48px;
}

.order_list .com_box {
  text-align: center;
  display: block;
}

.checkbox_all {
  margin: 0 14px;
}

.checkbox_table {
  margin: 0 20px 0 0;
}

#MergeFooter {
  margin-top: 20px;
  padding: 10px 0 0;
  border-top: 1px solid #E0E0E0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}

.mf_block {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  width: 33.33%;
}

.op_ov {
  padding: 0 10px;
  min-width: 110px;
}

.order_total {
  color: #5F6DAE;
}

.merge_operate {
  justify-content: flex-end;
}

/deep/ .shipping .el-input-group__prepend {
  background: none;
  border-color: #C8C8C8;
  padding: 0 10px;
}

/deep/ .shipping .el-input__inner {
  border-left: none;
  border-color: #C8C8C8;
  width: 80px;
  padding: 0;
  line-height: 1;
}

/deep/ .shipping .el-form-item.is-error .el-input-group__prepend,
/deep/ .shipping .el-form-item.is-error .el-input__inner {
  border-color: #F56C6C;
}

/deep/ .el-form-item {
  margin-bottom: 0;
}

/deep/ .el-form-item__error {
  top: 25%;
  left: auto;
  right: -145px;
}

.double_check {
  display: flex;
  flex-flow: row;
  justify-content: end;
  flex-wrap: wrap;
  padding: 20px 0;
}

.dbck_total {
  padding-bottom: 10px;
}

.total_row {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: end;
  line-height: 1.6;
}

.total_row span {
  text-align: right;
  min-width: 150px;
}

.total_row span:first-child {
  color: #A0A0A0;
}

.total_row:last-child span:last-child {
  font-size: 18px;
}

.total_row:last-child span {
  color: #5F6DAE;
}

.dbck_btns {
  width: 100%;
  display: flex;
  justify-content: end;
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/merge.vue